import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../Text';
import styles from './styles.scss';

export default class Heading extends Component {
  static propTypes = {
    large: PropTypes.bool,
    level: PropTypes.number,
    children: PropTypes.any,
    text: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { level = 1, children, text, large, className } = this.props;

    return React.createElement(
      `h${level}`,
      {
        className: classNames(className, {
          [styles[`h${level}-lg`]]: large,
        }),
      },
      children || <Text item={text} />,
    );
  }
}
